interface ColorScale {
  50?: string;
  100: string;
  200: string;
  300: string;
  400: string;
  500: string;
  600: string;
  700: string;
  800: string;
  900: string;
}

interface ShadeScale {
  0: string;
  100: string;
}

interface AccentsScale {
  blue: string;
}

interface ColourPalette {
  primary: ColorScale;
  error: ColorScale;
  warning: ColorScale;
  success: ColorScale;
  mint: ColorScale;
  teal: ColorScale;
  blue: ColorScale;
  violet: ColorScale;
  purple: ColorScale;
  neutral: ColorScale;
  shade: ShadeScale;
  accents: AccentsScale;
}

export const colours: ColourPalette = {
  primary: {
    100: '#FFD8E1',
    200: '#FFB3C2',
    300: '#FF7593',
    400: '#F65074',
    500: '#E30031',
    600: '#BD0029',
    700: '#B00026',
    800: '#740019',
    900: '#4C0010',
  },
  error: {
    50: '#FFE4D9',
    100: '#FFD4C2',
    200: '#FFB899',
    300: '#FFA680',
    400: '#FF9466',
    500: '#FF824D',
    600: '#D96736',
    700: '#AD4C23',
    800: '#6B2B10',
    900: '#331508',
  },
  warning: {
    100: '#FFEDB8',
    200: '#FFE494',
    300: '#FFDC73',
    400: '#FFD34F',
    500: '#F2C333',
    600: '#D9AD2E',
    700: '#AD8A23',
    800: '#6B5410',
    900: '#332808',
  },
  success: {
    100: '#E1FCC5',
    200: '#D0F5AB',
    300: '#C8F0A1',
    400: '#B5E882',
    500: '#9CDB5C',
    600: '#83C441',
    700: '#588F21',
    800: '#3C6315',
    900: '#1D3308',
  },
  mint: {
    100: '#C5FCDD',
    200: '#ABF5CB',
    300: '#A1F0C3',
    400: '#82E8AE',
    500: '#5CDB93',
    600: '#41C47A',
    700: '#218F50',
    800: '#156337',
    900: '#08331A',
  },
  teal: {
    100: '#BAE8FF',
    200: '#9EDFFF',
    300: '#85D6FF',
    400: '#5CC9FF',
    500: '#33BBFF',
    600: '#279ED9',
    700: '#1179AD',
    800: '#154F6B',
    900: '#062D40',
  },
  blue: {
    100: '#BAD1FF',
    200: '#9EBEFF',
    300: '#85ADFF',
    400: '#5C92FF',
    500: '#3377FF',
    600: '#2780D9',
    700: '#1145AD',
    800: '#15326B',
    900: '#061A40',
  },
  violet: {
    100: '#D6C2FF',
    200: '#BB99FF',
    300: '#AA80FF',
    400: '#9966FF',
    500: '#884DFF',
    600: '#6C36D9',
    700: '#5123AD',
    800: '#2E106B',
    900: '#160833',
  },
  purple: {
    100: '#FFC2FC',
    200: '#FF99FA',
    300: '#FF80F9',
    400: '#FF66F7',
    500: '#FF4DF6',
    600: '#D936D1',
    700: '#AD23A6',
    800: '#6B1067',
    900: '#330831',
  },
  neutral: {
    100: '#F6F7F7',
    200: '#EBECED',
    300: '#E0E4E5',
    400: '#C2C9CB',
    500: '#8F9C9F',
    600: '#5C6E73',
    700: '#294148',
    800: '#1A343B',
    900: '#001D25',
  },
  shade: {
    0: '#FFFFFF',
    100: '#000000',
  },
  accents: {
    blue: '#0088FF',
  },
};

export default colours;
